import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as personnel from '../../outcome-assignees'

export const RESOURCE = {
  payload: {
    description: 'Represents an assignment of a person to an outcome.',
    dimension: personnel.RESOURCE.payload,
    level: 0,
    name: 'Assignee',
    partialId: PartialId.Standard.create('assignee'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
